import { NgModule } from "@angular/core";
import { LegacyOrderHeaderComponent } from "@modules/core/components/bp-modal-header-order-variation/legacy-order-header/legacy-order-header.component";
import { PricesFacade } from "@modules/discover/domain/+state/prices.facade";
import { PricesInfiniteScrollFacade } from "@modules/discover/domain/+state/prices-infinite-scroll.facade";
import { PricesScrollService } from "@main-services/prices-scroll.service";
import { ActionButtonsFacade } from "@modules/discover/domain/+state/action-buttons.facade";
import { CryptoDepositFacade } from "@modules/+new/payments/features/crypto-deposit/domain/+state/crypto-deposit.facade";
import { CryptoDepositStateService } from "@modules/+new/payments/features/crypto-deposit/domain/+state/crypto-deposit-state.service";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [LegacyOrderHeaderComponent],
	imports: [CoreModule],
	exports: [LegacyOrderHeaderComponent],
	providers: [
		PricesFacade,
		PricesInfiniteScrollFacade,
		PricesScrollService,
		ActionButtonsFacade,
		CryptoDepositFacade,
		CryptoDepositStateService
	]
})
export class LegacyOrderHeaderModule {}
